import gql from 'graphql-tag';
import React from 'react';

import {GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import BenchlingQuery from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {getPipelineStepConfig} from 'pipelines/StepShapeUtils';
import getTestProps from 'test/lib/cypress/getTestProps';

import {
  GetResultSchemaNameQuery,
  GetResultSchemaNameQueryVariables,
} from './__generated/GetResultSchemaNameQuery';

/** @package */
export const GET_RESULT_SCHEMA_NAME_QUERY = gql`
  query GetResultSchemaNameQuery($schemaId: StrictString!) @skipAudit @engComponent(name: ANALYSIS_TOOL) {
    resultSchema(id: $schemaId) {
      ... on ResultSchemaNode {
        id
        name
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export default function ResultSchemaName({step}: {step: GetAnalysisPipelineStep}): JSX.Element {
  const schemaId = getPipelineStepConfig(step, PipelineStepType.SAVE_TO_RESULTS, 2).schemaId;
  return (
    <span {...getTestProps({component: 'ResultSchemaName', element: 'root'})}>
      <BenchlingQuery<GetResultSchemaNameQuery, GetResultSchemaNameQueryVariables>
        query={GET_RESULT_SCHEMA_NAME_QUERY}
        renderLoading={() => 'Loading...'}
        variables={{
          schemaId,
        }}
      >
        {(data) => (isInaccessible(data.resultSchema!) ? 'Inaccessible' : `${data.resultSchema!.name}`)}
      </BenchlingQuery>
    </span>
  );
}
